const componentStyles = (theme) => ({
  mainContent: {
    maxWidth: "100%",
    // Cards are white; the stock #f8f9fe body background sits too close to
    // that to separate them. Set here rather than on palette.background
    // because the body color comes from the compiled Argon SCSS, which wins
    // over CssBaseline.
    backgroundColor: theme.palette.pageBackground.main,
    minHeight: "100vh",
    // This is a flex item (flex: 1) beside the sidebar, and flex items default
    // to min-width: auto -- so a wide table stretched it past the viewport
    // instead of being constrained by it. The page then scrolled horizontally
    // and the table toolbar and pager were pushed out of view. With a lower
    // bound of 0 the column stays viewport-width and `.table-responsive`
    // finally has a bounded width to scroll the table inside.
    minWidth: 0,
  },
  containerRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
});

export default componentStyles;
